import script from "./AiInline.vue?vue&type=script&setup=true&lang=js"
export * from "./AiInline.vue?vue&type=script&setup=true&lang=js"

import "./AiInline.vue?vue&type=style&index=0&id=3c12c964&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c12c964"]])

export default __exports__